import FormJaivana from 'dashboard_jaivana_v1';

/**
 * @description: CustomAutorizarCosto
 * @author: Patricia Lopez Sanchez 
 * @version: jdesk_1.01.0009.13
 **/
class CustomAutorizarCosto extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm                        = this.initForm.bind(this);
        this.traercosto                      = this.traercosto.bind(this);
        this.successsTraercosto              = this.successsTraercosto.bind(this);
        this.grabar                          = this.grabar.bind(this);
        this.successsGrabar                  = this.successsGrabar.bind(this);
        this.calcularmargen                  = this.calcularmargen.bind(this);

    }

    initForm() {
        console.log('Formulario CustomAutorizarCosto,  @version: jdesk_1.01.0009.13, @author: Patricia Lopez Sanchez ');
        this.codigo_sucursal = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;

        this.getField('margen').setValue(0)
        if(this.props.data[0].opcion_sub_seccion === 1){
            this.modulo="FACTURACION"
            this.getField('nombre_formulario').setValue("AUTORIZAR COSTO");
        }else if(this.props.data[0].opcion_sub_seccion === 2){
            this.modulo="FACTURA_DESCUENTOS"
            this.getField('nombre_formulario').setValue("AUTORIZAR DESCUENTO");
        }

        this.getField("nit").setOnChange(()=> {
                this.getField("numero_autorizacion").setValue("")
        });
        this.getField("codigo_articulo").setDisabled(true);
        this.getField("nombre_articulo").setOnChange(()=> {
            if(this.getField("nombre_articulo").getValue() !== ""){
                this.traercosto();    
            }
        });
        this.getField("valor_sin_iva").setOnBlur(this.calcularmargen);
        this.getField("nombre_bodega").setOnChange(()=> {
            if(this.getField("nombre_bodega").getValue() !== ""){
                this.getField("codigo_articulo").setDisabled(false);
                let getField = this.getField;
                setTimeout(
                function()
                {
                    getField('codigo_articulo').input.focus();
                },20);
            }else{
                this.getField("codigo_articulo").setDisabled(true);
            }
        });

        this.getField('generar_autorizacion').setClick(this.grabar);
    }

    traercosto(){
        let datos={ datos: {
            codigo_articulo:this.getField('codigo_articulo').getValue(),
            codigo_bodega:this.getField('codigo_bodega').getValue(),
            codigo_sucursal:this.codigo_sucursal
        }};
        this.generalFormatPmv = { tipo_servicio: 'fact-autorizarcosto', operacion: 'traercosto', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successsTraercosto,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successsTraercosto(data){
        if (data.estado_p === 200 )
        {   
            this.getField('costo').setValue(data.data.costo);
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    calcularmargen(){
        if (this.getField('costo').getValue() !== 0 && this.getField('valor_sin_iva').getValue() !== 0) {
            if(this.getField('tasa').getValue() > 0){
                let precioTasa = this.getField('valor_sin_iva').getValue() * this.getField('tasa').getValue();
                this.getField('valor_sin_iva').setValue(precioTasa);
                let xmargen = this.getField('valor_sin_iva').getValue() - this.getField('costo').getValue();
                xmargen = xmargen / this.getField('valor_sin_iva').getValue();
                xmargen = xmargen * 100;
                this.getField('margen').setValue(xmargen.toFixed(2));
            }else{
                this.getField('margen').setValue(0);
                this.alertGeneral.toggle(true,'La tasa debe ser mayor o igual a 1.',"error");
            }
        }else{
            this.getField('margen').setValue(0);
            this.alertGeneral.toggle(true,'El costo debe ser mayor a 0 y el valor debe ser mayor o igual a 1.',"error");
        }
    }

    grabar(){
        if(this.getField('nit').valid() && this.getField('sede').valid() && this.getField('nombre').valid() && this.getField('codigo_bodega').valid()
         && this.getField('nombre_bodega').valid() && this.getField('codigo_articulo').valid() && this.getField('nombre_articulo').valid() 
         && this.getField('codigo_sucursal').valid() && this.getField('nombre_sucursal').valid() && this.getField('tasa').valid() &&
         this.getField('valor_sin_iva').valid() && this.getField('detalle').valid()){

            if(this.getField('tasa').getValue() !== 0){
                if(this.getField('valor_sin_iva').getValue() > 0){
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
                    this.getField('confirmModalCustom').setClickDialog(()=>{});  
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
                    let datos={ datos: {
                        codigo_articulo:this.getField('codigo_articulo').getValue(),
                        nombre_articulo:this.getField('nombre_articulo').getValue(),
                        codigo_bodega:this.getField('codigo_bodega').getValue(),
                        codigo_sucursal:this.getField('codigo_sucursal').getValue(),
                        nit:this.getField('nit').getValue(),
                        sede:this.getField('sede').getValue(),
                        nombre:this.getField('nombre').getValue(),
                        valor_sin_iva:this.getField('valor_sin_iva').getValue(),
                        costo:this.getField('costo').getValue(),
                        tasa:this.getField('tasa').getValue(),
                        margen:this.getField('margen').getValue(),
                        detalle:this.getField('detalle').getValue(),
                        usuarios_codigo:this.codigo_usuario,
                        value: this.modulo
                    }};
                    this.generalFormatPmv = { tipo_servicio: 'fact-autorizarcosto', operacion: 'grabar', operacion_tipo: 'consulta' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'GET',
                        body: datos,
                        success: this.successsGrabar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
                }else{
                    this.alertGeneral.toggle(true,'El valor debe ser mayor a 0.',"error");
                }
            }else{
                this.alertGeneral.toggle(true,'La tasa debe ser mayor o igual a 1.',"error");
            }
        }
    }

    successsGrabar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            this.limpiarcampos();
            this.getField("numero_autorizacion").setValue(data.data.aleatorio);
        }else{
            if(data.data.errores.mensaje!==undefined)
                this.mostrarMensajeAdicional(data.data.errores.mensaje);
        }
    }

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    limpiarcampos(){
        this.getField('codigo_articulo').setDisabled(true);
        this.getField('codigo_articulo').setValue('');
        this.getField('nombre_articulo').setValue('');
        this.getField('codigo_bodega').setValue('');
        this.getField('nombre_bodega').setValue('');
        this.getField('codigo_sucursal').setValue('');
        this.getField('nombre_sucursal').setValue('');
        this.getField('nit').setValue('');
        this.getField('sede').setValue('');
        this.getField('nombre').setValue('');
        this.getField('valor_sin_iva').setValue(0);
        this.getField('costo').setValue(0);
        this.getField('tasa').setValue(1);
        this.getField('margen').setValue(0);
        this.getField('detalle').setValue('');
        this.getField('numero_autorizacion').setValue('');
    }

}

FormJaivana.addController('fact-autorizarcosto',CustomAutorizarCosto);
export default CustomAutorizarCosto;